import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Footer from "../../component/Footer";
import SellerNavbar from "../../component/SellerNavbar";
import axios from "axios";
import { baseurl } from "../../Baseurl";
import { toast } from "react-toastify"; // Import Toastr
import "react-toastify/dist/ReactToastify.css";


const SellerOtp = () => {
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email") || ""; // Get email from URL
  const navigate = useNavigate();
 const [resending, setResending] = useState(false);
  const inputRefs = useRef([]);

  useEffect(() => {
    if (inputRefs.current[0]) {
      inputRefs.current[0].focus(); // Focus on first input when component mounts
    }
  }, []);

  // Handle OTP input change
  const handleOtpChange = (index, value) => {
    if (isNaN(value)) return; // Only allow numbers

    const newOtp = [...otp];
    newOtp[index] = value.slice(-1); // Only allow one character per box
    setOtp(newOtp);

    // Move focus to next box
    if (value && index < 5 && inputRefs.current[index + 1]) {
      inputRefs.current[index + 1].focus();
    }
  };

  // Handle backspace key
  const handleKeyDown = (index, event) => {
    if (event.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  // Handle OTP verification
  const handleVerifyOtp = async (e) => {
    e.preventDefault();
    setLoading(true);
    const enteredOtp = otp.join(""); // Combine all OTP inputs into a single string
  
    console.log("Sent Data:", { email, otp: enteredOtp }); // Log the sent data
  
    try {
      const response = await axios.post(`${baseurl}verify_otp`, {
        email,
        otp: enteredOtp,
      });
  
      console.log("API Response:", response); // Log the response from the API
  
      if (response.status === 200) {
        // Show success Toastr message
        toast.success("OTP verified successfully!");
  
        // Store seller data in localStorage
        localStorage.setItem("seller_id", response.data.data.id);
        localStorage.setItem("seller_email", response.data.data.email);
        localStorage.setItem("seller_first_name", response.data.data.first_name);
  
        // Navigate to seller dashboard after a delay (to let the toast show)
        setTimeout(() => {
          navigate("/seller/dashboard");
        }, 1500); // Delay to allow toast to show
      } else {
        setErrorMessage(response.data.message || "Invalid OTP. Please try again.");
      }
    } catch (error) {
      console.error("Error during OTP verification:", error); // Log the error
      setErrorMessage("An error occurred while verifying OTP.");
    } finally {
      setLoading(false);
    }
  };
  


  const [timer, setTimer] = useState(0);

  const handleResendOtp = async () => {
    try {
      setResending(true);
      setTimer(30); // Set timer for 30 seconds

      const response = await axios.post(`${baseurl}resendOtpSeller/${email}`);

      if (response.status === 200) {
        toast.success("OTP has been resent successfully!");
      } else {
        toast.error(response.data.message || "Failed to resend OTP.");
      }

      // Start countdown timer
      const countdown = setInterval(() => {
        setTimer((prev) => {
          if (prev === 1) {
            clearInterval(countdown);
            setResending(false);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    } catch (error) {
      console.error("Error resending OTP:", error);
      toast.error("An error occurred while resending OTP.");
      setResending(false);
    }
  };


  return (
    <>
      <SellerNavbar />
      <div>
        <section className="mb-5">
          <div className="container-fluid">
            <div className="row my-3 justify-content-center">
              <div className="col-md-5">
                <div className="reviewcls">
                  <h4 className="review-form-heading">Enter OTP</h4>
                  <p className="payttl">We have sent a 6-digit OTP to <b>{email}</b></p>
                  <hr />
                  <form onSubmit={handleVerifyOtp} className="contact-form text-center">
                    <div className="d-flex justify-content-center gap-2">
                      {otp.map((digit, index) => (
                        <input
                          key={index}
                          type="text"
                          className="form-control text-center"
                          maxLength="1"
                          value={digit}
                          onChange={(e) => handleOtpChange(index, e.target.value)}
                          onKeyDown={(e) => handleKeyDown(index, e)}
                          ref={(el) => (inputRefs.current[index] = el)}
                          style={{ width: "40px", height: "50px", fontSize: "1.5rem" }}
                        />
                      ))}
                    </div>

                    {errorMessage && (
                      <div className="mt-3 text-danger">
                        <p>{errorMessage}</p>
                      </div>
                    )}

                    <div className="mt-3">
                      <button type="submit" className="btn submitbtnn w-100" disabled={loading}>
                        {loading ? (
                          <>
                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>{" "}
                            Verifying...
                          </>
                        ) : (
                          "Verify OTP"
                        )}
                      </button>
                    </div>
                  </form>

                  <div className="mt-3 text-center">
                    <p>
                      Didn't receive the OTP?{" "}
                      <button className="btn btn-link p-0" onClick={handleResendOtp} disabled={resending}>
      {resending ? `Resend OTP in ${timer}s` : "Resend OTP"}
    </button>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default SellerOtp;
